import { cx } from "class-variance-authority";
import type { ReactNode } from "react";

import * as styles from "./Loader.module.scss";

export type LoaderProps = {
  text?: string;
  className?: string;
  children?: ReactNode;
};

export const Loader = ({
  text = "Loading",
  className,
  children,
}: LoaderProps) => (
  <div className={cx(styles.pageLoader, className)}>
    <div className={styles.loader}>
      <div className={styles.image}>{children}</div>
      <h3>{text}</h3>
    </div>
  </div>
);

export default Loader;
